import { SearchType } from '../constants';
import type { SavedSearch, Suggestion } from '../contracts';
import { highlightText } from '../utils';

type OwnProps = {
  data: SavedSearch[];
  inputValue?: string;
  searchType?: SearchType;
};

export default function normalizeSavedSearches({
  data,
  inputValue = ''
}: OwnProps): Suggestion[] {
  if (!data) return [];

  return data.map(savedSearch => {
    const { name, url } = savedSearch;

    return {
      searchType: SearchType.SavedSearch,
      text: name,
      highlightedText: highlightText(name, inputValue),
      searchHash: url,
      href: `/cars/filters?cvnaid=${url}`
    };
  });
}
